import { render } from "./AdmEditProdutoView.vue?vue&type=template&id=ef65a630"
import script from "./AdmEditProdutoView.vue?vue&type=script&lang=js"
export * from "./AdmEditProdutoView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__